export const AddToDelegationLogOptions = {
    now: 'now',
    later: 'later'
};

export const AddDocumentToBinderLogOptions = {
    now: 'now',
    later: 'later'
};

export const AddingUserOptions = {
    single: 'single',
    multiple: 'multiple'
};